module.exports = __webpack_public_path__ + "static/img/logo32.f333467.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo32.png
// module id = vlZo
// module chunks = 1